<template>
  <div id="wxframe" class="text-center m-t-10"></div>
</template>

<script>
export default {
  name: 'wxlogin',
  mounted () {
    window.WwLogin({
      id: 'wxframe',
      appid: 'wwe7a007eb6a2f2994',
      agentid: '1000005',
      scope: 'snsapi_login',
      redirect_uri: 'http://www.oohforce.com', // 转到当前地址以获取code值
      state: Math.random(),
      href: ''
    })
  }
}
</script>
